import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/:id',
	components: () => [import(/* webpackChunkName: 'travelBriefInfo' */ './component')],
	render: ([TravelBriefInfo]) => <TravelBriefInfo />,
};

export default routes;
